module.exports = __webpack_public_path__ + "static/media/left_fat.8f7d8890.svg";